import { JobDescription } from '../jobDescription';
import { JobCategory } from '../jobCategory';


export class JobDescriptionSerializer {
    fromJson(json: any): JobDescription {
        const data = new JobDescription();
        data.description = json.description;
        data.name = json.name;
        data.id = json.id;
        data.value = json.id;
        data.label = json.name;
        data.previousFileUrl=json.previousFileUrl;
        data.specialAttribute=json.specialAttribute;
        return data;
    }

    toJson(data: JobDescription): any {
        return {
            id: data.id,
            name: data.name,
            description: data.description,
            previousFileUrl:data.previousFileUrl,
            jobCategory:data.jobCategory,
            technology:data.technology,
            specialAttribute:data.specialAttribute
        };
    }
}